import React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow } from './SectionHead';
import Button from './Button';

/**
 * PageHero — L1 narrative hero for interior pages (05 §3.0).
 * Pass kicker to replace the long lead on compressed pillar pages.
 *
 * `image` (optional) is a public-path URL rendered as an atmospheric background
 * behind the hero text. It is kept deliberately dark and low-contrast (see the
 * `.cy-hero-media` overlay in cy-ui.css) so the ink voice and WCAG text contrast
 * are preserved — the photo is illustrative mood, never a claimed case photo.
 */
const PageHero = ({ id, eyebrow, title, lead, kicker, children, breadcrumb, image }) => (
  <section
    className={`cy-section cy-page-hero-section${image ? ' cy-hero-section--media' : ''}`}
    id={id}
  >
    {image ? (
      <div
        className="cy-hero-media"
        style={{ backgroundImage: `url(${image})` }}
        aria-hidden="true"
      />
    ) : null}
    <div className="cy-container">
      <div className="cy-page-hero">
        {breadcrumb}
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        <h1 className="cy-h1">{title}</h1>
        {kicker ? <p className="cy-kicker">{kicker}</p> : lead ? <p className="cy-lede">{lead}</p> : null}
        {children}
      </div>
    </div>
  </section>
);

const HeroCtas = ({ primary, primaryTo, secondary, secondaryTo, commit }) => (
  <div className="cy-hero-cta">
    <Button to={primaryTo}>{primary}</Button>
    {secondary ? (
      secondaryTo && secondaryTo.startsWith('#') ? (
        <a className="cy-link" href={secondaryTo}>
          {secondary}
        </a>
      ) : (
        <Link className="cy-link" to={secondaryTo}>
          {secondary}
        </Link>
      )
    ) : null}
    {commit ? <p className="cy-btn-commit">{commit}</p> : null}
  </div>
);

export { HeroCtas };
export default PageHero;
